import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const [activeLink, setActiveLink] = useState("");
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const storedActiveLink = localStorage.getItem("activeMenuLink");
    if (storedActiveLink) {
      setActiveLink(storedActiveLink);
    }
  }, []);

  const handleLinkClick = (link: string) => {
    setActiveLink(link);
    localStorage.setItem("activeMenuLink", link);
  };

  return (
    <footer>
      <div className="footer-nav-wrapper">
        <Link
          to={process.env.PUBLIC_URL + "/home"}
          className={`footer-nav-single ${
            location.pathname === process.env.PUBLIC_URL + "/home" ||
            location.pathname === process.env.PUBLIC_URL + "/"
              ? "active"
              : ""
          }`}
          onClick={() => handleLinkClick("home")}
        >
          <div className="menu-wrapper">
            <ReactSVG
              src={process.env.PUBLIC_URL + "/assets/img/icons/home.svg"}
            />
            <span>{t("home")}</span>
          </div>
        </Link>
        <Link
          to={process.env.PUBLIC_URL + "/annoucement"}
          className={`footer-nav-single ${
            location.pathname === process.env.PUBLIC_URL + "/annoucement"
              ? "active"
              : ""
          }`}
          onClick={() => handleLinkClick("news")}
        >
          <div className="menu-wrapper">
            <ReactSVG
              src={process.env.PUBLIC_URL + "/assets/img/icons/news.svg"}
            />
            <span>{t("news")}</span>
          </div>
        </Link>
        <Link
          to={process.env.PUBLIC_URL + "/community"}
          className={`footer-nav-single ${
            location.pathname === process.env.PUBLIC_URL + "/community"
              ? "active"
              : ""
          }`}
          onClick={() => handleLinkClick("community")}
        >
          <div className="menu-wrapper">
            <ReactSVG
              src={process.env.PUBLIC_URL + "/assets/img/icons/community.svg"}
            />
            <span>{t("community")}</span>
          </div>
        </Link>
        <Link
          to={process.env.PUBLIC_URL + "/wallet"}
          className={`footer-nav-single ${
            location.pathname === process.env.PUBLIC_URL + "/wallet"
              ? "active"
              : ""
          }`}
          onClick={() => handleLinkClick("wallet")}
        >
          <div className="menu-wrapper">
            <ReactSVG
              src={process.env.PUBLIC_URL + "/assets/img/icons/wallet.svg"}
            />
            <span>{t("wallet")}</span>
          </div>
        </Link>
        <Link
          to={process.env.PUBLIC_URL + "/cart"}
          className={`footer-nav-single ${
            location.pathname === process.env.PUBLIC_URL + "/cart"
              ? "active"
              : ""
          }`}
          onClick={() => handleLinkClick("cart")}
        >
          <div className="menu-wrapper">
            <ReactSVG
              src={process.env.PUBLIC_URL + "/assets/img/icons/cart.svg"}
            />
            <span>{t("cart")}</span>
          </div>
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
